<input
  #fotoInput
  type="file"
  accept="image/*"
  class="foto-input-oculto"
  (change)="onFotoSelecionada($event)"
/>

<div class="camera-overlay" *ngIf="cameraAberta" role="dialog" aria-modal="true">
  <div class="camera-panel">
    <p class="camera-titulo">Foto — {{ alunoCameraAlvo?.pessoaNome }}</p>
    <div class="camera-video-wrap">
      <video
        #videoPreview
        class="camera-video"
        autoplay
        playsinline
        muted
      ></video>
      <div class="camera-loading" *ngIf="cameraInicializando">
        <nb-spinner status="primary"></nb-spinner>
        <span>Iniciando câmera…</span>
      </div>
    </div>
    <div class="camera-botoes">
      <button
        nbButton
        status="success"
        size="small"
        (click)="capturarDaCamera()"
        [disabled]="cameraInicializando"
      >
        Capturar
      </button>
      <button nbButton status="basic" size="small" (click)="cancelarCamera()">
        Cancelar
      </button>
      <button
        nbButton
        status="basic"
        size="small"
        outline
        (click)="escolherArquivoEmVezDaCamera()"
      >
        Galeria ou arquivo
      </button>
    </div>
  </div>
</div>

<div
  class="foto-popup-overlay"
  *ngIf="fotoPopupAberta"
  role="dialog"
  aria-modal="true"
  (click)="fecharFotoPopup()"
>
  <div class="foto-popup-panel" (click)="$event.stopPropagation()">
    <div class="foto-popup-header">
      <span class="foto-popup-titulo">{{ fotoPopupTitulo }}</span>
      <button
        type="button"
        nbButton
        ghost
        size="small"
        class="foto-popup-fechar"
        aria-label="Fechar"
        (click)="fecharFotoPopup()"
      >
        ×
      </button>
    </div>
    <div class="foto-popup-body">
      <img
        *ngIf="fotoPopupUrl"
        class="foto-popup-imagem"
        [src]="fotoPopupUrl"
        alt="Foto do catequizando"
        (error)="onFotoPopupErro()"
      />
    </div>
  </div>
</div>

<div class="row mt-3" *ngIf="errosCarregar && !carregando">
  <div class="col-lg-12">
    <nb-card class="card-erro">
      <nb-card-body>{{ errosCarregar }}</nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="carregando">
  <div class="col-lg-12">
    <nb-card>
      <nb-card-body class="carregando-box">
        <nb-spinner status="primary"></nb-spinner>
        <span>Carregando frequência…</span>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="frequencia && !carregando">
  <div class="col-lg-12">
    <p class="toolbar-data">
      <label class="label-data">Data do encontro</label>
      <input
        nbInput
        type="date"
        fieldSize="small"
        [(ngModel)]="data"
        (ngModelChange)="onDataChange()"
      />
      <span class="persistindo" *ngIf="persistindo">
        <nb-spinner size="tiny" status="primary"></nb-spinner>
        Salvando…
      </span>
    </p>
    <nb-card>
      <nb-card-header>
        <div class="cabecalho-frequencia">
          <div>
            <span class="subtitulo">Frequência da turma</span>
            <h3 class="nome-turma">{{ frequencia.turmaNome || 'Turma ' + turmaId }}</h3>
            <span class="data-leg">{{ dataFormatada }}</span>
          </div>
          <div class="resumo">
            <span class="somente-leitura" *ngIf="!podeEditar && !verificandoVinculo">
              Somente leitura — você não é catequista desta turma
            </span>
            <span class="sep" *ngIf="!podeEditar && !verificandoVinculo">·</span>
            <span><strong>{{ totalPresentes }}</strong> presentes (encontro)</span>
            <span class="sep">·</span>
            <span><strong>{{ totalFaltas }}</strong> faltas</span>
            <ng-container *ngIf="frequenciaMissaAtiva">
              <span class="sep">·</span>
              <span><strong>{{ totalPresentesMissa }}</strong> na missa</span>
            </ng-container>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="tabela-scroll">
          <table class="table table-frequencia table-hover">
            <thead>
              <tr>
                <th rowspan="2" class="th-num">#</th>
                <th class="th-nome" [attr.colspan]="frequenciaMissaAtiva ? 4 : 3">Nome</th>
              </tr>
              <tr>
                <th class="th-acao">Presença</th>
                <th class="th-acao" *ngIf="frequenciaMissaAtiva">Na missa</th>
                <th colspan="2" class="th-acao">Foto / telefone</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let aluno of frequencia.alunos; let i = index">
                <tr
                  class="frequencia-linha-nome"
                  [class.frequencia-sep-entre-alunos]="i > 0"
                  [ngClass]="i % 2 === 0 ? 'frequencia-bloco-par' : 'frequencia-bloco-impar'"
                >
                  <td rowspan="2" class="cel-numero">{{ i + 1 }}</td>
                  <td class="cel-nome" [attr.colspan]="frequenciaMissaAtiva ? 4 : 3">{{ aluno.pessoaNome }}</td>
                </tr>
                <tr
                  class="frequencia-linha-acoes"
                  [ngClass]="i % 2 === 0 ? 'frequencia-bloco-par' : 'frequencia-bloco-impar'"
                >
                  <td class="cel-acao cel-checkbox">
                    <span class="acao-label">Encontro</span>
                    <nb-checkbox
                      [ngModel]="aluno.presente === true"
                      [disabled]="!podeEditar"
                      (ngModelChange)="onPresenteChange(aluno, $event)"
                    ></nb-checkbox>
                  </td>
                  <td class="cel-acao cel-checkbox" *ngIf="frequenciaMissaAtiva">
                    <span class="acao-label">Missa</span>
                    <nb-checkbox
                      [ngModel]="aluno.presenteMissa === true"
                      [disabled]="!podeEditar"
                      (ngModelChange)="onPresenteMissaChange(aluno, $event)"
                    ></nb-checkbox>
                  </td>
                  <td colspan="2" class="cel-acao cel-foto">
                    <div class="cel-foto-telefone-wrap">
                      <div class="acao-grupo-foto">
                        <span class="acao-label">Foto</span>
                        <div class="cel-foto-botoes">
                          <button
                            *ngIf="temFoto(aluno)"
                            nbButton
                            status="success"
                            size="tiny"
                            class="btn-foto"
                            (click)="verFoto(aluno)"
                          >
                            Ver foto
                          </button>
                          <button
                            *ngIf="!temFoto(aluno)"
                            nbButton
                            status="danger"
                            size="tiny"
                            class="btn-foto"
                            [disabled]="uploadFotoParaPessoaId === aluno.pessoaId"
                            (click)="abrirCamera(aluno)"
                          >
                            {{
                              uploadFotoParaPessoaId === aluno.pessoaId ? 'Enviando…' : 'Tirar foto'
                            }}
                          </button>
                        </div>
                      </div>
                      <div class="acao-grupo-telefone">
                        <span class="acao-label">Telefone</span>
                        <button
                          type="button"
                          nbButton
                          size="tiny"
                          class="btn-foto btn-telefone-freq"
                          [status]="temTelefonePessoa(aluno) ? 'success' : 'danger'"
                          [title]="tituloBotaoTelefone(aluno)"
                          (click)="abrirEditarTelefone(aluno)"
                        >
                          {{ textoBotaoTelefone(aluno) }}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div class="frequencia-fim-scroll" aria-hidden="true"></div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
